import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useGLTF } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import { useFormStore } from '../../state/FormStore';

export function LeftGSDoor({ verandaSize, verandaColor, opaalTexture, playTexture, nodes, materials }) {
    //const { formData, getNumberOfGlassDoors } = useFormStore();
    const numberOfDoors = 3; // Fetch number of doors dynamically
    const [isOpen, setIsOpen] = useState(false);
    const [targetPosition, setTargetPosition] = useState(null);
    const formData = useFormStore(state => state.formData.linker.linker_wand_option);

    const doorWidth = 1 / numberOfDoors * 1.11;

    const [doorRefs, setDoorRefs] = useState([]);

    useEffect(() => {
        // Initialize refs when numberOfDoors changes
        setDoorRefs(Array(numberOfDoors).fill().map(() => React.createRef()));
    }, [numberOfDoors]);


    useEffect(() => {
        if (formData) {
            setIsOpen(true); // Start the animation when formData changes
            setTargetPosition(doorRefs[0]?.current?.position.z || 0); // Set target position based on the first door's position

            // Set a timeout to revert the doors back to the original position
            const timeoutId = setTimeout(() => {
                setIsOpen(false);
            }, 1000); // Adjust the delay as needed (2000ms = 2 seconds)

            return () => clearTimeout(timeoutId); // Cleanup timeout if formData changes again
        }
    }, [formData, doorRefs]); // Run this effect when formData or doorRefs change


    useFrame(() => {
        if (isOpen) {
            doorRefs.forEach((doorRef, index) => {
                if (doorRef.current) {
                    doorRef.current.position.z += (targetPosition - doorRef.current.position.z) * 0.05; // Adjust animation speed as needed
                }
            });
        } else {
            doorRefs.forEach((doorRef, index) => {
                if (doorRef.current) {
                    doorRef.current.position.z += (index * (doorWidth * 0.4) - (numberOfDoors - 1) * doorWidth * 0.4 / 2 - doorRef.current.position.z) * 0.05; // Return to original position
                }
            });
        }
    });


    const handleDoorClick = useCallback((index) => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            // Set target position to the position of the first door
            setTargetPosition(0 * doorWidth * 0.4 - (numberOfDoors - 1) * doorWidth * 0.4 / 2);
        }
    }, [isOpen, doorRefs]);


    return (

        <group name="glass_slding_door" scale={verandaSize}>
            <mesh
                castShadow
                receiveShadow
                onClick={handleDoorClick}
                geometry={nodes.play_left.geometry}>
                <meshStandardMaterial attach="material" map={playTexture} transparent opacity={1} />
            </mesh>



            <mesh
                castShadow
                receiveShadow
                geometry={nodes.gs_topfleft.geometry}
                material={materials['glassframe:lambert1.001']}
            >
                <meshStandardMaterial attach="material" color={verandaColor[0]} />
            </mesh>

            {Array.from({ length: numberOfDoors }).map((_, index) => (
                <group key={index} name={`glass_frame_${index}`}>
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.gs_bottomfleft.geometry}
                        material={materials['glassframe:lambert2']}
                    />
                </group>
            ))}

            {doorRefs.map((doorRef, index) => (
                <group key={index} ref={doorRef}
                    position={[index * 0.005, 0, index * doorWidth * 0.4 - (numberOfDoors - 1) * doorWidth * 0.4 / 2]}
                    onClick={() => handleDoorClick(index)} // Handle click event
                >
                    <group name="Glass_Door" scale={[1, 1, doorWidth]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.glassdoor_left_1.geometry}
                            material={nodes.glassdoor_left_1.material}
                        >
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.glassdoor_left_2.geometry}
                            material={nodes.glassdoor_left_2.material}
                        >
                            <meshStandardMaterial attach="material" map={opaalTexture} color={"#8de3c7"} transparent opacity={0.3} />

                        </mesh>

                    </group>
                </group>
            ))}
        </group>
    );
}

// Ensure GLTF model is preloaded
//useGLTF.preload('/veranda3/veranda3.glb');
